var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoCrudContainer',{ref:"list",attrs:{"as-table":"","prepend-new-item":"","fetch-fn":_vm.getVmDetails,"columns":_vm.tableColumns},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('span')]},proxy:true},{key:"memoryLimit",fn:function(ref){
var item = ref.item;
return [(item.memoryLimit === -1)?_c('td',{staticClass:"resource-link"},[_vm._v(" "+_vm._s(_vm.$tc('unlimited'))+" ")]):_c('td',{staticClass:"resource-link"},[_vm._v(_vm._s(item.memoryLimit))])]}},{key:"assetName",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('a',{attrs:{"href":_vm.$router.resolve(
            item['ci']
              ? _vm.$modules.getModuleRoute('cmdb', 'view', {
                  params: { id: item.id, ciType: _vm.$constants.CMDB },
                })
              : _vm.$modules.getModuleRoute('asset', 'view', {
                  params: {
                    id: item.id,
                    assetType: _vm.$constants.ASSET_HARDWARE,
                  },
                })
          ).href,"target":"_blank"}},[_vm._v(_vm._s(item.assetName)+" ")])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }